import React from "react";
import styles from "../statics/styles/file-upload-viewer-scss";
const XlsIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M35.5 41.5h-32V.5h19.45L35.5 13.31z" }), /* @__PURE__ */ React.createElement("path", { d: "m22.59 13.36 12.91-.05-.64-.63L23.59 1.14 22.95.5z" })), /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "M17.29 30.55h-2.67l3.54-5.6-3.36-5.4h2.74l1.96 3.58 2.02-3.58h2.65l-3.36 5.31 3.57 5.69h-2.79L19.5 26.8z"
  }
)));
export {
  XlsIcon
};
//# sourceMappingURL=xls-icon.js.map
